import { useState, useEffect } from 'react'

export interface Product {
  title: string
  editionLabel: string
  priceNumber: number
  priceText: string
  thumbnailUrl: string
}

export function useProductScanner() {
  const [products, setProducts] = useState<Product[]>([])
  useEffect(() => {
    const scanDOM = () => {
      const foundProducts: Product[] = []
      // Find all elements that might contain a price
      const elements = Array.from(document.querySelectorAll('*')).filter(
        (el) => {
          // Only look at elements with direct text content (leaf-ish nodes)
          if (el.children.length > 1) return false
          const text = el.textContent || ''
          if (!text.match(/\$|USD|€/)) return false
          if (!text.match(/[\d.,]+/)) return false
          // Skip old/discounted prices
          if (
            el.closest('.line-through') ||
            el.classList.contains('line-through')
          )
            return false
          return true
        },
      )
      elements.forEach((el) => {
        // Find a logical container for the product
        const container = el.closest(
          'button, .rounded-2xl, section, article, .group',
        )
        if (!container) return
        // Extract Title
        const titleEl = container.querySelector(
          'h2, h3, .font-black, .font-bold',
        )
        const title = titleEl?.textContent?.trim()
        if (!title) return
        // Extract Subtitle / Edition Label
        const subtitleEl = container.querySelector(
          'p.text-white\\/60, p.text-white\\/80, .text-sm',
        )
        const editionLabel =
          subtitleEl?.textContent?.trim() || 'Edizione Digitale'
        // Extract Price
        const priceText = el.textContent?.trim() || ''
        const rawNumberStr = priceText
          .replace(/[^\d,.-]/g, '')
          .replace(/\./g, '')
          .replace(',', '.')
        const priceNumber = parseFloat(rawNumberStr) || 0
        // Extract Image (look nearby, or fallback to first image on page)
        const imgEl =
          container.querySelector('img') || document.querySelector('img')
        const thumbnailUrl =
          (imgEl as HTMLImageElement | null)?.src ||
          'https://cdn.magicpatterns.com/uploads/pJZQQ1y91fqaN7VirMLzzV/oDiXxM0087776.webp'
        // Deduplicate by title
        if (!foundProducts.some((p) => p.title === title)) {
          foundProducts.push({
            title,
            editionLabel,
            priceNumber,
            priceText,
            thumbnailUrl,
          })
        }
      })
      // Fallback in case the DOM structure changes or scanner finds nothing
      if (foundProducts.length === 0) {
        foundProducts.push(
          {
            title: 'COLLEZIONE COMPLETA',
            editionLabel: '4 volumi + 3 bonus in regalo',
            priceNumber: 22,
            priceText: '22 €',
            thumbnailUrl:
              'https://cdn.magicpatterns.com/uploads/pJZQQ1y91fqaN7VirMLzzV/oDiXxM0087776.webp',
          },
          {
            title: 'COLLEZIONE COMPLETA + GUIDA PSICOLOGICA',
            editionLabel: 'Tutto il precedente + Guida Psicologica',
            priceNumber: 31,
            priceText: '31 €',
            thumbnailUrl:
              'https://cdn.magicpatterns.com/uploads/pJZQQ1y91fqaN7VirMLzzV/oDiXxM0087776.webp',
          },
        )
      }
      setProducts(foundProducts)
    }
    // Small delay to ensure all components are mounted and rendered
    const timer = setTimeout(scanDOM, 1500)
    return () => clearTimeout(timer)
  }, [])
  return products
}
